/**
 * StateShell — the framing for the workshop detail page's error/not-found
 * states (a back link + a warning-toned message). Extracted from
 * WorkshopDetailPage so each component lives in its own file.
 */
import { Link } from 'react-router-dom';

export function StateShell({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ padding: 24 }}>
      <Link to=".." style={{ color: 'var(--nb-primary)', fontSize: 12.5 }}>
        ‹ Back to workshops
      </Link>
      <div style={{ marginTop: 12, color: 'var(--nb-warn)' }}>{children}</div>
    </div>
  );
}
